export default commomImport => [{
  name: 'login',
  path: `/login`,
  hidden: true,
  component: commomImport('login/login.vue')
}];
